import React from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { useFormik } from 'formik';
import { PaymentsEftRecordType } from '../../../models/DeprecatedEnums';
import { PaymentValidations } from '../../../validations/PaymentValidations';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Button from '@mui/material/Button';
import Select from '@mui/material/Select';
import { GeneralHelper } from '../../../helpers/GeneralHelper';

interface ChangeEftRecordTypeComponentProps {
  selectedRecord: any;
  updateRecordType: any;
  toggleDialog: (show: boolean) => void;
  show: boolean;
}

const ChangeEftRecordTypeComponent = (props: ChangeEftRecordTypeComponentProps) => {
  const { selectedRecord, updateRecordType, show, toggleDialog } = props;
  const recordType = selectedRecord.recordType ? selectedRecord.recordType : PaymentsEftRecordType.EFT;

  const defaultForm: any = {
    recordType: recordType
  };

  const formik = useFormik({
    initialValues: defaultForm,
    validationSchema: PaymentValidations.changeEftRecordTypeValidation(),
    onSubmit: async values => {
      if (!selectedRecord) return;
      updateRecordType(values.recordType);
    }
  });

  return (
    <Dialog open={show} onClose={() => toggleDialog(false)} maxWidth={'sm'} fullWidth={true}>
      <DialogTitle>Change Type</DialogTitle>
      <DialogContent>
        <form autoComplete={'off'} autoCorrect={'off'} onSubmit={formik.handleSubmit} className={'form'}>
          <p>Please ensure you select the correct type before processing the request.</p>
          <div className={'form-group mt-4'}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Type</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="Type"
                defaultValue={recordType}
                error={GeneralHelper.formFieldHasError(formik, 'recordType')}
                {...formik.getFieldProps('recordType')}
              >
                <MenuItem value={PaymentsEftRecordType.EFT}>{PaymentsEftRecordType.EFT}</MenuItem>
                <MenuItem value={PaymentsEftRecordType.FEE}>{PaymentsEftRecordType.FEE}</MenuItem>
                <MenuItem value={PaymentsEftRecordType.CASH}>{PaymentsEftRecordType.CASH}</MenuItem>
                <MenuItem value={PaymentsEftRecordType.SWIFT}>{PaymentsEftRecordType.SWIFT}</MenuItem>
                <MenuItem value={PaymentsEftRecordType.OTHER}>{PaymentsEftRecordType.OTHER}</MenuItem>
              </Select>
            </FormControl>
          </div>

          <div className={'row align-items-center'}>
            <div className={'col-auto'}>
              <Button variant={'text'} onClick={() => toggleDialog(false)}>
                Cancel
              </Button>
            </div>
            <div className={'col'}>
              <Button variant={'contained'} disableElevation={true} type={'submit'}>
                Change type
              </Button>
            </div>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default ChangeEftRecordTypeComponent;
